export const BTMS_TOKEN_KEY = "btms_token";
export const BTMS_USER_KEY = "btms_user";

export const ROLES = {
  ADMIN: "ADMIN",
  OWNER: "OWNER",
  MANAGER: "MANAGER",
  STAFF: "STAFF",
  PLAYER: "PLAYER",
};
